module.exports = {"232764100":"呼中镇","232764101":"碧水镇","232764102":"呼源镇","232764103":"宏伟镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/232764.json
// module id = 906
// module chunks = 0